module.exports = __webpack_public_path__ + "img/active-first.2608e0ad.png";